const AssignedOptions = {
  ALL: "all",
  ASSIGNED: "assigned",
  NOTASSIGNED: "notAssigned",
};

export { AssignedOptions };
